export default __webpack_public_path__ + "static/media/home-decor-img-09.db7f3290.jpg";